import NewsFeed from "./components/NewsFeed"
import CurrencyConverter from "./components/CurrencyConverter"


const App = () => {
  return (

      <body>
    <div className="app">
        <CurrencyConverter/>
        <NewsFeed/>
    </div>
      </body>
  )
}

export default App
